module.exports = __webpack_public_path__ + "img/heated.b414646e.svg";